import * as React from "react";
import { Image } from "react-datocms";
import { TrackLink } from "../TrackLink";
import ACTIONS from "../EventLibrary";
import { useRouter } from "next/router";

export function GridBase({ items, withLink, limit, inline = false, seeMore = true }) {
    const router = useRouter();

    const [expand, setExpand] = React.useState(false);


    const items2 = expand ?
        items
        : items.slice(0, limit);

    return <div className="grid place-items-center grid-cols-8">
        {
            items2.map((x, i) => {

                const href = withLink(x);

                return href ? <div key={i} className="flex item">
                    <TrackLink href={href} action={ACTIONS.docs_networkgrid_clicked}>
                        {x.imgwhite?.responsiveImage &&
                            <Image
                                data={x.imgwhite.responsiveImage}
                                pictureClassName="cover-image"
                                usePlaceholder={false}
                            />
                        }
                    </TrackLink>
                </div>
                    : <div key={i} className="flex item">
                        {x.imgwhite?.responsiveImage &&
                            <Image
                                data={x.imgwhite.responsiveImage}
                                pictureClassName="cover-image"
                                usePlaceholder={false}
                            />
                        }
                    </div>;
            })
        }
        
        {(expand || items.length < limit) ? null : <div className={`flex item see-more ${inline ? "see-more-inline" : ""}`} onClick={() => {
            if(seeMore){
                setExpand(true);    
            }else{
                router.push(`/docs/networks/`, undefined, { shallow: true });
            }
        }}>See more</div>}
        <style jsx>
            {`
            
            .grid-cols-8 {
                grid-template-columns: repeat(6, minmax(0, 1fr));                
            }
            :global(.dark .grid-cols-8) {
                grid-template-columns: repeat(7, minmax(0, 1fr));                
            }
            @media screen and (max-width: 767px) {
                .grid-cols-8 {
                    grid-template-columns: repeat(4, minmax(0, 1fr));                
                }
                .grid .item {
                    font-size: var(--font-size-2);
                }
            }
            @media screen and (max-width: 500px) {
                .grid-cols-8 {
                    grid-template-columns: repeat(4, minmax(0, 1fr));                
                }
                .grid .item {
                    font-size: 10px;
                }
            }
            
            .place-items-center {
                place-items: center;
            }
            .grid {
                display: grid;
                gap: 0;
                margin-top: 1rem;
                border-top: solid 1px;
                border-left: solid 1px;
                border-color: var(--border-color);
            }
            :global(.dark .grid) {
                gap: 1px;
                border: 0px;
                border-radius: calc(var(--border-radius) * 1);
                overflow: hidden;
                background: var(--gray);
                z-index: 1;
            }
            :global(.dark .grid .item) {
                border: 0;
            }
            :global(.dark .grid .item .cover-image) {
                border-radius: 0;
            }
            .item {
                border-right: solid 1px;
                border-bottom: solid 1px;
                border-color: var(--border-color);
                padding: 0;
                grid-column: span 1 / span 1;
                aspect-ratio: 1;
                transition: 0.2s;
            }
            .item:hover {
                box-shadow: 0px 0px 20px -15px;
                z-index: 2;
                transition: 0.2s;
            }
            .see-more {
                font-weight:var(--font-weight-bold);
                background: white;
                display:flex;
                align-items:center;
                justify-content:center;
                color: #2D2D2D;
                width:100%;
                height:100%;
                font-size: var(--font-size-4);

            }
            .see-more:hover{
                color: #ff4c8b;
                cursor: pointer;
            }
            .see-more-inline {
                 cursor: pointer;
            }
            
            `}
        </style>
    </div >;
}
